<template>
  <div>
    <div class="content">
      <van-cell-group>
        <van-cell title="车挂号" :value="detail.cheguahao" :title-class="titleClass" :value-class="valueClass"/>
        <van-cell title="所属车队" :value="detail.sscd" :title-class="titleClass" :value-class="valueClass"/>
        <van-cell title="是否集装箱" :value="detail.sfjzxzz" :title-class="titleClass" :value-class="valueClass"/>
        <div v-show="vehicleUsageName">
          <van-cell title="车辆证件用途" :value="vehicleUsageName" :title-class="titleClass" :value-class="valueClass" />
        </div>

        <van-cell title="整备质量" :value="detail.zhengbeizhiliang?detail.zhengbeizhiliang:0" :title-class="titleClass" :value-class="valueClass">
          <template #extra>
            <div class="unit">KG</div>
          </template>
        </van-cell>

        <!-- <van-cell title="总质量" :value="detail.zongzhiliang?detail.zongzhiliang:0" :title-class="titleClass" :value-class="valueClass">
          <template #extra>
            <div class="unit">KG</div>
          </template>
        </van-cell> -->

        <van-cell title="行驶证核定载质量" :value="detail.xingshizhenghdzzl?detail.xingshizhenghdzzl:0" :title-class="titleClass" :value-class="valueClass">
          <template #extra>
            <div class="unit">吨</div>
          </template>
        </van-cell>

        <van-cell title="行驶证有效期" :value="detail.xingshizhengyxq" :title-class="titleClass" :value-class="valueClass"/>
        <div v-if="detail.xingshizhengzbfmurl">
          <van-cell title="行驶证正页" :title-class="titleClass"/>
          <div class="imageBox"><van-image :src="detail.xingshizhengzbfmurl" /></div>
        </div>
        <div v-if="detail.xingshizhengfbzmurl">
          <van-cell title="行驶证副页" :title-class="titleClass"/>
          <div class="imageBox"><van-image :src="detail.xingshizhengfbzmurl" /></div>
        </div>
        <div v-if="detail.xingshizhengfbfmurl">
          <van-cell title="行驶证副页反面" :title-class="titleClass"/>
          <div class="imageBox"><van-image :src="detail.xingshizhengfbfmurl" /></div>
        </div>
        <div v-if="detail.xingshizhengzbzmurl">
          <van-cell title="行驶证机动车照片" :title-class="titleClass"/>
          <van-image :src="detail.xingshizhengzbzmurl" />
        </div>

        <div v-if="detail.cangshi">
          <van-cell title="舱室" :title-class="titleClass" :value="detail.cangshiTitle"/>
        </div>

          <van-cell title="货舱数" :title-class="titleClass" :value="detail.cssl"/>

        <div v-if="detail.cangshi == '02' || detail.cangshi == '03'">
          <van-cell title="前舱室立方" :title-class="titleClass" :value="detail.cangshilifang1"/>
        </div>
        <div v-if="detail.cangshi == '02' || detail.cangshi == '03'">
          <van-cell :title="cs2Lable" :title-class="titleClass" :value="detail.cangshilifang2"/>
        </div>
        <div v-if="detail.cangshi == '03'">
          <van-cell title="后舱室立方" :title-class="titleClass" :value="detail.cangshilifang3"/>
        </div>


        <div v-if="detail.vehicleUsage == '2'">
          <van-cell title="道路运输证有效期" :value="detail.daoluyszyxq" :title-class="titleClass" :value-class="valueClass"/>
          <van-cell title="道路运输证经营范围" :value="detail.daoluyszjyfw" :title-class="titleClass" :value-class="valueClass"/>

          <div v-if="detail.daoluyszzbzmurl">
            <van-cell title="道路运输证正本正面图片" :title-class="titleClass"/>
            <div class="imageBox"><van-image :src="detail.daoluyszzbzmurl" /></div>
          </div>
          <div v-if="detail.daoluyszdlzmurl">
            <van-cell title="道路运输证（待理证）正面图片(包含车辆信息及经营范围)" :title-class="titleClass"/>
            <div class="imageBox"><van-image :src="detail.daoluyszdlzmurl" /></div>
          </div>
          <div v-if="detail.daoluyszdlfmurl">
            <van-cell title="道路运输证（待理证）反面图片" :title-class="titleClass"/>
            <div class="imageBox"><van-image :src="detail.daoluyszdlfmurl" /></div>
          </div>

          <div v-if="detail.guanjianbgurl">
            <van-cell title="罐体图片" :title-class="titleClass"/>
            <van-cell v-for="item in guanjianbgurlList" :key="item.id">
              <div class="imageBox"><van-image :src="item.url" /></div>
            </van-cell>
          </div>

          <van-cell title="罐体体积" :value="detail.guantitiji?detail.guantitiji:0" :title-class="titleClass" :value-class="valueClass">
            <template #extra>
              <div class="unit">立方</div>
            </template>
          </van-cell>

          <van-cell title="罐体材质" :value="detail.guanticaizi" :title-class="titleClass" :value-class="valueClass"/>
          <van-cell title="罐检有效期" :value="detail.guanjianyxq" :title-class="titleClass" :value-class="valueClass"/>
          <van-cell title="罐检经营范围" :value="detail.guanjianjyfw" :title-class="titleClass" :value-class="valueClass"/>
        </div>

        <van-cell title="备注" :value="detail.beizhu" :title-class="titleClass" :value-class="valueClass"/>
      </van-cell-group>
    </div>
    <Tabbar></Tabbar>
  </div>
</template>

<script>
import api from '@/fetch/api'
import {
  Toast
} from 'vant';
import Tabbar from '../Public/tabbarTpl.vue'
export default {
  components: {
    Tabbar
  },
  data() {
    return {
      id: "",
      detail: [],
      guanjianbgurlList: [],
      guanjianbgImageArr: [],
      titleClass:"title-class-hq",
      valueClass:"value-class-hq",
      cs2Lable:"",
      vehicleUsageName:"",
    }
  },
  created() {
    document.title = "车挂信息详情";
    var id = this.$route.params.id;
    this.$data.id = id;
    this.getCheguaBeianDetail(id);
  },
  methods: {
    getUsage(typecode)
    {
      var that = this;
      var typeGroupName = "vehicleUsage";
      api.getTypeList(typeGroupName).then(function(res) {
        var resData = JSON.parse(res);
        if (resData.success == true) {
          var result = resData.obj;
          that.resultList = result;
          result.forEach((item) => {
            if(typecode == item.typecode) that.vehicleUsageName = item.typename;

          });
        } else {
          Toast.fail(resData.message);
        }
      }).catch(function() {
        //
      });
    },
    getCheguaBeianDetail(id) {
      var that = this;
      var weburl = that.GLOBAL.weburl;
      api.getCheguaBeianDetail(id).then(function(resData) {
        var res = JSON.parse(resData);
        if (res.respCode == 0) {
          var detail = res.data;
          detail.xingshizhengzbzmurl = detail.xingshizhengzbzmurl ? weburl + '/' + detail.xingshizhengzbzmurl : "";
          detail.xingshizhengzbfmurl = detail.xingshizhengzbfmurl ? weburl + '/' + detail.xingshizhengzbfmurl : "";
          detail.xingshizhengfbzmurl = detail.xingshizhengfbzmurl ? weburl + '/' + detail.xingshizhengfbzmurl : "";
          detail.xingshizhengfbfmurl = detail.xingshizhengfbfmurl ? weburl + '/' + detail.xingshizhengfbfmurl : "";
          detail.daoluyszzbzmurl = detail.daoluyszzbzmurl ? weburl + '/' + detail.daoluyszzbzmurl : "";
          detail.daoluyszdlzmurl = detail.daoluyszdlzmurl ? weburl + '/' + detail.daoluyszdlzmurl : "";
          detail.daoluyszdlfmurl = detail.daoluyszdlfmurl ? weburl + '/' + detail.daoluyszdlfmurl : "";
          if(detail.vehicleUsage) that.getUsage(detail.vehicleUsage)

          switch (detail.cangshi) {
            case "01":
              detail.cangshiTitle = "单舱";
              that.cs2Lable = "";
              break;
            case "02":
              that.cs2Lable = "后舱室立方";
              detail.cangshiTitle = "双舱";
              break;
            case "03":
              that.cs2Lable = "中舱室立方";
              detail.cangshiTitle = "三舱";
              break;
            // default:
            //   that.cangshiTitle = "";
            //   this.cs2Lable = "后舱室立方";
          }
          if(detail.sfjzx == 'Y'){
            detail.sfjzxzz = '是';
          }else{
            detail.sfjzxzz = '否';
          }

          that.$data.detail = detail;

          var guanjianbgurl = detail.guanjianbgurl;
          var guanjianbgImageArr = that.guanjianbgImageArr;
          //var guanjianbgurlArr = that.guanjianbgurlArr;
          if (guanjianbgurl) {
            var imageDataArr = guanjianbgurl.split(',');
            for (var k = 0; k < imageDataArr.length; k++) {
              if (guanjianbgImageArr.length > 0) {
                guanjianbgImageArr.push({
                  'url': weburl + '/' + imageDataArr[k]
                });
              } else {
                guanjianbgImageArr = imageDataArr[k] ? [{
                  url: weburl + '/' + imageDataArr[k]
                }] : [];
              }
            }

            that.guanjianbgurlList = that.guanjianbgimage = that.guanjianbgImageArr = guanjianbgImageArr;
          }
        }
      }).catch(function(err) {
        console.log(err);
        Toast.fail('连接失败，请刷新页面');
      });
    },
  }
}
</script>

<style lang="scss" scoped>
html{
  background: #fff;
}
.content {
  margin-top: 1rem;
  margin-bottom: 3.75rem;
  padding-bottom: env(safe-area-inset-bottom);
  .imageBox {
    margin: 0 1rem;
    padding: 0.875rem 0;
    border: 1px solid #ebedf0;
  }
}

.unit {
  padding-left: 0.2rem;
  color: #969799;
}
</style>
